import { Component, input, output } from '@angular/core';

import { ControlType } from '../../models/control-room-models';

@Component({
  selector: 'app-automatic-flow-scheduler',
  templateUrl: './automatic-flow-scheduler.component.html',
  styleUrls: ['./automatic-flow-scheduler.component.scss'],
  standalone: false,
})
export class AutomaticFlowSchedulerComponent {
  // Inputs using signals
  enabledState = input<boolean | null>(null);
  schedulerType = input<ControlType>(ControlType.unknown);
  loading = input<boolean>(false);

  // Outputs using signals
  activate = output<ControlType>();
  activateNow = output<ControlType>();
  stop = output<ControlType>();

  // Emit actions using signals
  onActivate() {
    this.activate.emit(this.schedulerType());
  }

  onActivateNow() {
    this.activateNow.emit(this.schedulerType());
  }

  onStop() {
    this.stop.emit(this.schedulerType());
  }
}
